import axios from 'axios';

export const listTermSheetsApi = async ({ customerId }) => {
  const response = await axios.get(`admin/customer/${customerId}/term-sheets`);
  return response.data;
};

export const getTermSheetApi = async ({ customerId, termSheetId }) => {
  const response = await axios.get(
    `admin/customer/${customerId}/term-sheets/${termSheetId}`
  );
  return response.data;
};

export const saveTermSheetApi = async ({ customerId, data }) => {
  const response = await axios.post(
    `admin/customer/${customerId}/term-sheets`,
    data
  );
  return response.data;
};

export const updateTermSheetSentApi = async ({ customerId, termSheetId, sentToClient }) => {
  await axios.patch(
    `admin/customer/${customerId}/term-sheets/${termSheetId}/sent`,
    { sentToClient }
  );
};

export const deleteTermSheetApi = async ({ customerId, termSheetId }) => {
  await axios.delete(
    `admin/customer/${customerId}/term-sheets/${termSheetId}`
  );
};

export const exportTermSheetToDriveApi = async ({
  customerId,
  docxBlob,
  docxFilename,
}) => {
  const form = new FormData();
  form.append('docx', docxBlob, docxFilename);
  const response = await axios.post(
    `admin/customer/${customerId}/term-sheets/export-to-drive`,
    form
  );
  return response.data;
};
